import { useAuth } from "src/hooks/useAuth";
import Main from "src/components/core/Main";

import DashboardSeller from "./DashboardSeller";
import DashboardAdmin from "./DashboardAdmin";

function ProductDashboard({ open }) {
  const { user } = useAuth();
  return (
    <Main open={open}>
      {user?.role_id === 1 ? <DashboardAdmin /> : <DashboardSeller />}
    </Main>
  );
}
export default ProductDashboard;
